"use strict";
(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[821],{

/***/ 56042:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* reexport */ Button_Button; }
});

// EXTERNAL MODULE: ../../node_modules/@emotion/react/jsx-runtime/dist/emotion-react-jsx-runtime.browser.esm.js
var emotion_react_jsx_runtime_browser_esm = __webpack_require__(52903);
// EXTERNAL MODULE: ../../node_modules/react/index.js
var react = __webpack_require__(2784);
// EXTERNAL MODULE: ./src/utils/environment/index.ts
var environment = __webpack_require__(98404);
// EXTERNAL MODULE: ../../node_modules/@emotion/react/dist/emotion-react.browser.esm.js
var emotion_react_browser_esm = __webpack_require__(28165);
// EXTERNAL MODULE: ../../node_modules/@emotion/styled/dist/emotion-styled.browser.esm.js + 4 modules
var emotion_styled_browser_esm = __webpack_require__(82227);
;// CONCATENATED MODULE: ./src/components/atoms/Button/Button.styles.tsx
function _taggedTemplateLiteral(strings, raw) {
    if (!raw) {
        raw = strings.slice(0);
    }
    return Object.freeze(Object.defineProperties(strings, {
        raw: {
            value: Object.freeze(raw)
        }
    }));
}
function _templateObject() {
    var data = _taggedTemplateLiteral([
        "\n    border: 1px solid;\n    border-radius: 16px;\n    cursor: pointer;\n    display: block;\n    font-weight: ",
        ";\n    height: auto;\n    text-align: center;\n    text-decoration: none;\n    transition: background-color ",
        ", opacity ",
        ";\n    width: fit-content;\n    font-family: ",
        ";\n\n    span {\n      vertical-align: middle;\n    }\n\n    &:active {\n      opacity: 0.75;\n    }\n\n    &:disabled {\n      cursor: not-allowed;\n    }\n\n    ",
        ";\n    ",
        ";\n    ",
        ";\n    ",
        ";\n  "
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}


var wrapperModifiers = {
    fullWidth: function() {
        return /*#__PURE__*/ (0,emotion_react_browser_esm.css)("width:100%;");
    },
    withIcon: function() {
        return /*#__PURE__*/ (0,emotion_react_browser_esm.css)("align-items:center;display:inline-flex;justify-content:center;svg{height:20px;width:20px;}svg + span{margin-left:10px;}");
    }
};
var variantModifiers = {
    primary: function(theme) {
        return /*#__PURE__*/ (0,emotion_react_browser_esm.css)("background-color:", theme.colors.brandColor1, ";border-color:", theme.colors.brandColor1, ";color:", theme.colors.white, ";&:hover{background-color:", theme.colors.brandColor1Darkened, ";border-color:", theme.colors.brandColor1Darkened, ";}&:disabled{background-color:", theme.colors.gray3, ";border-color:", theme.colors.gray3, ";color:", theme.colors.white, ";}");
    },
    secondary: function(theme) {
        return /*#__PURE__*/ (0,emotion_react_browser_esm.css)("background-color:", theme.colors.red, ";border-color:", theme.colors.red, ";color:", theme.colors.white, ";&:hover{background-color:", theme.colors.redDarkened, ";border-color:", theme.colors.redDarkened, ";}&:disabled{background-color:", theme.colors.gray3, ";border-color:", theme.colors.gray3, ";color:", theme.colors.white, ";}");
    },
    alternate: function(theme) {
        return /*#__PURE__*/ (0,emotion_react_browser_esm.css)("background-color:", theme.colors.white, ";border-color:", theme.colors.brandColor1, ";color:", theme.colors.brandColor1, ";&:hover{background-color:", theme.colors.brandColor1Light, ";}&:disabled{background-color:", theme.colors.gray1, ";border-color:", theme.colors.gray3, ";color:", theme.colors.gray3, ";}");
    },
    alternate2: function(theme) {
        return /*#__PURE__*/ (0,emotion_react_browser_esm.css)("background-color:", theme.colors.brandColor1Light, ";border-color:", theme.colors.brandColor1Light, ";color:", theme.colors.brandColor1, ";&:hover{filter:brightness(0.95);}&:disabled{background-color:", theme.colors.gray1, ";border-color:", theme.colors.gray1, ";color:", theme.colors.gray3, ";filter:brightness(1);}");
    }
};
var sizeModifiers = {
    small: function(theme) {
        return /*#__PURE__*/ (0,emotion_react_browser_esm.css)("padding:8px;font-size:", theme.font.sizes.xsmall, ";");
    },
    medium: function(theme) {
        return /*#__PURE__*/ (0,emotion_react_browser_esm.css)("padding:16px;font-size:", theme.font.sizes.small, ";");
    },
    large: function(theme) {
        return /*#__PURE__*/ (0,emotion_react_browser_esm.css)("padding:21px;font-size:", theme.font.sizes.small, ";");
    }
};
var Wrapper = /*#__PURE__*/ (0,emotion_styled_browser_esm["default"])("button", {
    target: "ebjwbf90"
})(function(param) {
    var theme = param.theme, fullWidth = param.fullWidth, size = param.size, hasIcon = param.hasIcon, variant = param.variant;
    return (0,emotion_react_browser_esm.css)(_templateObject(), theme.font.weight.bold, theme.transition.default, theme.transition.default, theme.font.family.averta, !!fullWidth && wrapperModifiers.fullWidth(), hasIcon && wrapperModifiers.withIcon(), sizeModifiers[size](theme), variantModifiers[variant](theme));
});

;// CONCATENATED MODULE: ./src/components/atoms/Button/Button.tsx
function _defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _defineProperty(target, key, source[key]);
        });
    }
    return target;
}
function _objectWithoutProperties(source, excluded) {
    if (source == null) return {};
    var target = _objectWithoutPropertiesLoose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function _objectWithoutPropertiesLoose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}




var Button = /*#__PURE__*/ (0,react.forwardRef)(function(_param, ref) /*#__PURE__*/ {
    var children = _param.children, _fullWidth = _param.fullWidth, fullWidth = _fullWidth === void 0 ? false : _fullWidth, _asLink = _param.asLink, asLink = _asLink === void 0 ? false : _asLink, _size = _param.size, size = _size === void 0 ? "medium" : _size, _variant = _param.variant, variant = _variant === void 0 ? "primary" : _variant, icon = _param.icon, props = _objectWithoutProperties(_param, [
        "children",
        "fullWidth",
        "asLink",
        "size",
        "variant",
        "icon"
    ]);
    return (0,emotion_react_jsx_runtime_browser_esm.jsxs)(Wrapper, _objectSpread({
        className: "ButtonStyles__Wrapper",
        fullWidth: fullWidth,
        size: size,
        variant: variant,
        hasIcon: !!icon,
        ref: ref
    }, asLink ? {
        as: "a"
    } : {}, props, {
        children: [
            icon,
            !!children && /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm.jsx)("span", {
                children: children
            })
        ]
    }));
});
if (environment/* isDevelopment */.y) {
    Button.displayName = "Button";
}
/* harmony default export */ var Button_Button = (Button);

;// CONCATENATED MODULE: ./src/components/atoms/Button/index.ts




/***/ }),

/***/ 4969:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* reexport */ FormErrorMessage_FormErrorMessage; }
});

// EXTERNAL MODULE: ../../node_modules/@emotion/react/jsx-runtime/dist/emotion-react-jsx-runtime.browser.esm.js
var emotion_react_jsx_runtime_browser_esm = __webpack_require__(52903);
// EXTERNAL MODULE: ../../node_modules/react/index.js
var react = __webpack_require__(2784);
// EXTERNAL MODULE: ./src/components/icons/index.tsx + 99 modules
var icons = __webpack_require__(46912);
// EXTERNAL MODULE: ../../node_modules/@emotion/react/dist/emotion-react.browser.esm.js
var emotion_react_browser_esm = __webpack_require__(28165);
// EXTERNAL MODULE: ../../node_modules/@emotion/styled/dist/emotion-styled.browser.esm.js + 4 modules
var emotion_styled_browser_esm = __webpack_require__(82227);
;// CONCATENATED MODULE: ./src/components/atoms/FormErrorMessage/FormErrorMessage.styles.tsx
function _taggedTemplateLiteral(strings, raw) {
    if (!raw) {
        raw = strings.slice(0);
    }
    return Object.freeze(Object.defineProperties(strings, {
        raw: {
            value: Object.freeze(raw)
        }
    }));
}
function _templateObject() {
    var data = _taggedTemplateLiteral([
        "\n    align-items: center;\n    background-color: rgba(235, 87, 87, 0.1); // theme.colors.red at 0.1 opacity\n    border: 0.5px solid rgba(235, 87, 87, 0.5); // theme.colors.red at 0.5 opacity\n    border-radius: 6px;\n    color: ",
        ";\n    display: flex;\n    margin-bottom: 20px;\n    padding: 6.5px 10px;\n\n    svg {\n      height: 12px;\n      margin-right: 8px;\n    }\n  "
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}


var Wrapper = /*#__PURE__*/ (0,emotion_styled_browser_esm["default"])("div", {
    target: "e742rpk0"
})(function(param) {
    var theme = param.theme;
    return (0,emotion_react_browser_esm.css)(_templateObject(), theme.colors.red);
});
var Message = /*#__PURE__*/ (0,emotion_styled_browser_esm["default"])("p", {
    target: "e742rpk1"
})("font-size:11px;");

;// CONCATENATED MODULE: ./src/components/atoms/FormErrorMessage/FormErrorMessage.tsx




var FormErrorMessage = function(param) {
    var message = param.message;
    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm.jsxs)(Wrapper, {
        className: "FormErrorMessageStyles__Wrapper",
        children: [
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm.jsx)(icons/* AlertTriangleIcon */.lM, {}),
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm.jsx)(Message, {
                children: message
            })
        ]
    });
};
/* harmony default export */ var FormErrorMessage_FormErrorMessage = (FormErrorMessage);

;// CONCATENATED MODULE: ./src/components/atoms/FormErrorMessage/index.ts




/***/ }),

/***/ 85787:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "fS": function() { return /* binding */ AuthFormWrapper; },
/* harmony export */   "Qd": function() { return /* binding */ AuthFormTitle; },
/* harmony export */   "Bt": function() { return /* binding */ AuthForm; },
/* harmony export */   "y6": function() { return /* binding */ AuthFromSection; },
/* harmony export */   "GB": function() { return /* binding */ FooterOptionText; }
/* harmony export */ });
/* harmony import */ var _emotion_styled__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(82227);
/* harmony import */ var _emotion_react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(28165);
function _taggedTemplateLiteral(strings, raw) {
    if (!raw) {
        raw = strings.slice(0);
    }
    return Object.freeze(Object.defineProperties(strings, {
        raw: {
            value: Object.freeze(raw)
        }
    }));
}
function _templateObject() {
    var data = _taggedTemplateLiteral([
        "\n    background-color: ",
        ";\n    border-radius: 33px;\n    padding: 40px;\n    width: 360px;\n  "
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = _taggedTemplateLiteral([
        "\n    color: ",
        ";\n    font-size: 26px;\n    font-weight: ",
        ";\n    margin-bottom: 40px;\n  "
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function _templateObject2() {
    var data = _taggedTemplateLiteral([
        "\n    color: ",
        ";\n    font-size: ",
        ";\n    font-weight: ",
        ";\n    white-space: nowrap;\n\n    a {\n      color: currentColor;\n      font-weight: ",
        ";\n      text-decoration: none;\n\n      &:hover {\n        text-decoration: underline;\n      }\n    }\n  "
    ]);
    _templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}


var AuthFormWrapper = /*#__PURE__*/ (0,_emotion_styled__WEBPACK_IMPORTED_MODULE_0__["default"])("div", {
    target: "e108q8z60"
})(function(param) {
    var theme = param.theme;
    return (0,_emotion_react__WEBPACK_IMPORTED_MODULE_1__.css)(_templateObject(), theme.colors.lightBg);
});
var AuthFormTitle = /*#__PURE__*/ (0,_emotion_styled__WEBPACK_IMPORTED_MODULE_0__["default"])("h2", {
    target: "e108q8z61"
})(function(param) {
    var theme = param.theme;
    return (0,_emotion_react__WEBPACK_IMPORTED_MODULE_1__.css)(_templateObject1(), theme.colors.gray8, theme.font.weight.normal);
});
var AuthForm = /*#__PURE__*/ (0,_emotion_styled__WEBPACK_IMPORTED_MODULE_0__["default"])("form", {
    target: "e108q8z62"
})("display:grid;grid-gap:40px;gap:40px;");
var AuthFromSection = /*#__PURE__*/ (0,_emotion_styled__WEBPACK_IMPORTED_MODULE_0__["default"])("div", {
    target: "e108q8z63"
})("display:grid;gap:20px;grid-gap:20px;");
var FooterOptionText = /*#__PURE__*/ (0,_emotion_styled__WEBPACK_IMPORTED_MODULE_0__["default"])("p", {
    target: "e108q8z64"
})(function(param) {
    var theme = param.theme;
    return (0,_emotion_react__WEBPACK_IMPORTED_MODULE_1__.css)(_templateObject2(), theme.colors.gray7, theme.font.sizes.xsmall, theme.font.weight.normal, theme.font.weight.bold);
});


/***/ }),

/***/ 87164:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* reexport */ PasswordRules_PasswordRules; }
});

// EXTERNAL MODULE: ../../node_modules/@emotion/react/jsx-runtime/dist/emotion-react-jsx-runtime.browser.esm.js
var emotion_react_jsx_runtime_browser_esm = __webpack_require__(52903);
// EXTERNAL MODULE: ../../node_modules/react/index.js
var react = __webpack_require__(2784);
// EXTERNAL MODULE: ./src/utils/validations/index.ts + 1 modules
var validations = __webpack_require__(73954);
// EXTERNAL MODULE: ./src/hooks/useBoolean/index.ts + 1 modules
var useBoolean = __webpack_require__(80491);
;// CONCATENATED MODULE: ./src/hooks/useRulesForPassword.tsx
function _arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function _arrayWithHoles(arr) {
    if (Array.isArray(arr)) return arr;
}
function _iterableToArrayLimit(arr, i) {
    var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"];
    if (_i == null) return;
    var _arr = [];
    var _n = true;
    var _d = false;
    var _s, _e;
    try {
        for(_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true){
            _arr.push(_s.value);
            if (i && _arr.length === i) break;
        }
    } catch (err) {
        _d = true;
        _e = err;
    } finally{
        try {
            if (!_n && _i["return"] != null) _i["return"]();
        } finally{
            if (_d) throw _e;
        }
    }
    return _arr;
}
function _nonIterableRest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _slicedToArray(arr, i) {
    return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest();
}
function _unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return _arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(n);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen);
}



var PASSWORD_MINIMUM_ACCEPTED_CHARACTERS = 8;
var useRulesForPassword = function(password) {
    var ref = _slicedToArray((0,useBoolean/* useBoolean */.k)(false), 2), isValidPassword = ref[0], setIsValidPassword = ref[1];
    var passwordHasEnoughCharacters = password.length >= PASSWORD_MINIMUM_ACCEPTED_CHARACTERS;
    var passwordHasSpecialCharacter = (0,validations/* hasSpecialCharacter */.RC)(password);
    var passwordHasNumber = (0,validations/* hasNumber */.Yo)(password);
    (0,react.useEffect)(function() {
        var isValid = (0,validations/* validatePassword */.uo)(password).isValid;
        setIsValidPassword.setValue(!!isValid);
    }, [
        password,
        setIsValidPassword
    ]);
    return {
        passwordHasEnoughCharacters: passwordHasEnoughCharacters,
        passwordHasSpecialCharacter: passwordHasSpecialCharacter,
        passwordHasNumber: passwordHasNumber,
        isValidPassword: isValidPassword
    };
};

// EXTERNAL MODULE: ../../node_modules/@emotion/react/dist/emotion-react.browser.esm.js
var emotion_react_browser_esm = __webpack_require__(28165);
// EXTERNAL MODULE: ../../node_modules/@emotion/styled/dist/emotion-styled.browser.esm.js + 4 modules
var emotion_styled_browser_esm = __webpack_require__(82227);
// EXTERNAL MODULE: ./src/components/icons/index.tsx + 99 modules
var icons = __webpack_require__(46912);
;// CONCATENATED MODULE: ./src/components/molecules/PasswordRules/PasswordRules.styles.tsx
function _taggedTemplateLiteral(strings, raw) {
    if (!raw) {
        raw = strings.slice(0);
    }
    return Object.freeze(Object.defineProperties(strings, {
        raw: {
            value: Object.freeze(raw)
        }
    }));
}
function _templateObject() {
    var data = _taggedTemplateLiteral([
        "\n      box-shadow: -8px 8px 18px rgba(0, 0, 0, 0.06);\n    "
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = _taggedTemplateLiteral([
        "\n    background-color: ",
        ";\n    border-radius: 16px;\n    height: fit-content;\n    min-width: 305px;\n    padding: 26px 30px 28px 24px;\n    width: 100%;\n\n    ",
        "\n  "
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function _templateObject2() {
    var data = _taggedTemplateLiteral([
        "\n    color: ",
        ";\n    margin-bottom: 24px;\n    font-size: ",
        ";\n  "
    ]);
    _templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function _templateObject3() {
    var data = _taggedTemplateLiteral([
        "\n    color: ",
        ";\n    font-size: ",
        ";\n    line-height: 14px;\n  "
    ]);
    _templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}
function _templateObject4() {
    var data = _taggedTemplateLiteral([
        "\n    list-style: ",
        ";\n    position: relative;\n  "
    ]);
    _templateObject4 = function _templateObject4() {
        return data;
    };
    return data;
}



var Wrapper = /*#__PURE__*/ (0,emotion_styled_browser_esm["default"])("div", {
    target: "et3wmfl0"
})(function(param) {
    var theme = param.theme, backgroundColor = param.backgroundColor, isBoxShadow = param.isBoxShadow;
    return (0,emotion_react_browser_esm.css)(_templateObject1(), backgroundColor || theme.colors.lightBg, isBoxShadow && (0,emotion_react_browser_esm.css)(_templateObject()));
});
var Title = /*#__PURE__*/ (0,emotion_styled_browser_esm["default"])("h3", {
    target: "et3wmfl1"
})(function(param) {
    var theme = param.theme;
    return (0,emotion_react_browser_esm.css)(_templateObject2(), theme.colors.gray7, theme.font.sizes.small);
});
var Text = /*#__PURE__*/ (0,emotion_styled_browser_esm["default"])("p", {
    target: "et3wmfl2"
})(function(param) {
    var theme = param.theme;
    return (0,emotion_react_browser_esm.css)(_templateObject3(), theme.colors.gray7, theme.font.sizes.xsmall);
});
var List = /*#__PURE__*/ (0,emotion_styled_browser_esm["default"])("ul", {
    target: "et3wmfl3"
})("margin-top:20px;padding-left:24px;");
var ListItem = /*#__PURE__*/ (0,emotion_styled_browser_esm["default"])("li", {
    target: "et3wmfl4"
})(function(param) {
    var isValid = param.isValid;
    return (0,emotion_react_browser_esm.css)(_templateObject4(), isValid ? "none" : "disc");
});
var GreenCheckMarkIcon = /*#__PURE__*/ (0,emotion_styled_browser_esm["default"])(icons/* CheckMarkIcon */.Ol, {
    target: "et3wmfl5"
})("position:absolute;left:-17px;bottom:5px;width:9.2px;");

;// CONCATENATED MODULE: ./src/components/molecules/PasswordRules/PasswordRules.tsx
function _defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _defineProperty(target, key, source[key]);
        });
    }
    return target;
}
function _objectWithoutProperties(source, excluded) {
    if (source == null) return {};
    var target = _objectWithoutPropertiesLoose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function _objectWithoutPropertiesLoose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}




var PasswordRules_PASSWORD_MINIMUM_ACCEPTED_CHARACTERS = 8;
var PasswordRules = function(_param) {
    var password = _param.password, backgroundColor = _param.backgroundColor, _isBoxShadow = _param.isBoxShadow, isBoxShadow = _isBoxShadow === void 0 ? false : _isBoxShadow, props = _objectWithoutProperties(_param, [
        "password",
        "backgroundColor",
        "isBoxShadow"
    ]);
    var ref = useRulesForPassword(password), passwordHasEnoughCharacters = ref.passwordHasEnoughCharacters, passwordHasSpecialCharacter = ref.passwordHasSpecialCharacter, passwordHasNumber = ref.passwordHasNumber;
    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm.jsxs)(Wrapper, _objectSpread({
        backgroundColor: backgroundColor,
        isBoxShadow: isBoxShadow
    }, props, {
        children: [
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm.jsx)(Title, {
                children: "Rules for Passwords"
            }),
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm.jsx)(Text, {
                children: "To create a new password, you have to meet all the following requirements:"
            }),
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm.jsxs)(List, {
                children: [
                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm.jsxs)(ListItem, {
                        isValid: passwordHasEnoughCharacters,
                        children: [
                            passwordHasEnoughCharacters && /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm.jsx)(GreenCheckMarkIcon, {}),
                            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm.jsxs)(Text, {
                                children: [
                                    "Minimum ",
                                    PasswordRules_PASSWORD_MINIMUM_ACCEPTED_CHARACTERS,
                                    " characters"
                                ]
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm.jsxs)(ListItem, {
                        isValid: passwordHasSpecialCharacter,
                        children: [
                            passwordHasSpecialCharacter && /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm.jsx)(GreenCheckMarkIcon, {}),
                            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm.jsx)(Text, {
                                children: "At least one special character (@, &, etc)"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm.jsxs)(ListItem, {
                        isValid: passwordHasNumber,
                        children: [
                            passwordHasNumber && /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm.jsx)(GreenCheckMarkIcon, {}),
                            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm.jsx)(Text, {
                                children: "At least one number"
                            })
                        ]
                    })
                ]
            })
        ]
    }));
};
/* harmony default export */ var PasswordRules_PasswordRules = (PasswordRules);

;// CONCATENATED MODULE: ./src/components/molecules/PasswordRules/index.ts




/***/ }),

/***/ 54301:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* reexport */ PasswordWithRulesCard_PasswordWithRulesCard; }
});

// EXTERNAL MODULE: ../../node_modules/@emotion/react/jsx-runtime/dist/emotion-react-jsx-runtime.browser.esm.js
var emotion_react_jsx_runtime_browser_esm = __webpack_require__(52903);
// EXTERNAL MODULE: ../../node_modules/react/index.js
var react = __webpack_require__(2784);
// EXTERNAL MODULE: ../../node_modules/@emotion/react/dist/emotion-react.browser.esm.js
var emotion_react_browser_esm = __webpack_require__(28165);
// EXTERNAL MODULE: ./src/components/atoms/TextField/index.ts + 3 modules
var TextField = __webpack_require__(46903);
// EXTERNAL MODULE: ./src/components/molecules/PasswordRules/index.ts + 3 modules
var PasswordRules = __webpack_require__(87164);
// EXTERNAL MODULE: ./src/hooks/useBoolean/index.ts + 1 modules
var useBoolean = __webpack_require__(80491);
;// CONCATENATED MODULE: ./src/components/organisms/PasswordWithRulesCard/PasswordWithRulesCard.tsx
function _arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function _arrayWithHoles(arr) {
    if (Array.isArray(arr)) return arr;
}
function _iterableToArrayLimit(arr, i) {
    var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"];
    if (_i == null) return;
    var _arr = [];
    var _n = true;
    var _d = false;
    var _s, _e;
    try {
        for(_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true){
            _arr.push(_s.value);
            if (i && _arr.length === i) break;
        }
    } catch (err) {
        _d = true;
        _e = err;
    } finally{
        try {
            if (!_n && _i["return"] != null) _i["return"]();
        } finally{
            if (_d) throw _e;
        }
    }
    return _arr;
}
function _nonIterableRest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _slicedToArray(arr, i) {
    return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest();
}
function _unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return _arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(n);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen);
}






var PasswordWithRulesCard = function(param) {
    var _label = param.label, label = _label === void 0 ? "Password" : _label, password = param.password, error = param.error, isValid = param.isValid, onChange = param.onChange, onBlur = param.onBlur;
    var ref = _slicedToArray((0,useBoolean/* useBoolean */.k)(), 2), isShowingPasswordRules = ref[0], setIsShowingPasswordRules = ref[1];
    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm.jsxs)("div", {
        css: /*#__PURE__*/ (0,emotion_react_browser_esm.css)("position:relative;"),
        children: [
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm.jsx)(TextField/* default */.Z, {
                label: label,
                name: "password",
                type: "password",
                error: error,
                isValid: isValid,
                onChange: onChange,
                onFocus: setIsShowingPasswordRules.setTrue,
                onBlur: function(e) {
                    onBlur === null || onBlur === void 0 ? void 0 : onBlur(e);
                    setIsShowingPasswordRules.setFalse();
                },
                required: true
            }),
            isShowingPasswordRules && /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm.jsx)(PasswordRules/* default */.Z, {
                isBoxShadow: true,
                password: password,
                css: /*#__PURE__*/ (0,emotion_react_browser_esm.css)("position:absolute;left:calc(100% + 20px);/* Label Height */\n            top:23px;")
            })
        ]
    });
};
/* harmony default export */ var PasswordWithRulesCard_PasswordWithRulesCard = (/*#__PURE__*/react.memo(PasswordWithRulesCard));

;// CONCATENATED MODULE: ./src/components/organisms/PasswordWithRulesCard/index.ts




/***/ }),

/***/ 34328:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ Auth; }
});

// EXTERNAL MODULE: ../../node_modules/@emotion/react/jsx-runtime/dist/emotion-react-jsx-runtime.browser.esm.js
var emotion_react_jsx_runtime_browser_esm = __webpack_require__(52903);
// EXTERNAL MODULE: ../../node_modules/react/index.js
var react = __webpack_require__(2784);
// EXTERNAL MODULE: ../../node_modules/next/image.js
var next_image = __webpack_require__(96577);
// EXTERNAL MODULE: ../../node_modules/next/link.js
var next_link = __webpack_require__(39097);
// EXTERNAL MODULE: ../../node_modules/next/router.js
var next_router = __webpack_require__(5632);
// EXTERNAL MODULE: ../../node_modules/@emotion/react/dist/emotion-react.browser.esm.js
var emotion_react_browser_esm = __webpack_require__(28165);
// EXTERNAL MODULE: ../../node_modules/@emotion/styled/dist/emotion-styled.browser.esm.js + 4 modules
var emotion_styled_browser_esm = __webpack_require__(82227);
;// CONCATENATED MODULE: ./src/components/molecules/AuthHeaderNav/AuthHeaderNav.styles.tsx
function _taggedTemplateLiteral(strings, raw) {
    if (!raw) {
        raw = strings.slice(0);
    }
    return Object.freeze(Object.defineProperties(strings, {
        raw: {
            value: Object.freeze(raw)
        }
    }));
}
function _templateObject() {
    var data = _taggedTemplateLiteral([
        "\n    color: ",
        ";\n    cursor: pointer;\n    font-size: ",
        ";\n    font-weight: ",
        ";\n    white-space: nowrap;\n    width: 100%;\n  "
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}


var Wrapper = /*#__PURE__*/ (0,emotion_styled_browser_esm["default"])("div", {
    target: "et75v90"
})("align-content:center;display:flex;justify-content:space-between;width:100%;");
var Logo = /*#__PURE__*/ (0,emotion_styled_browser_esm["default"])("a", {
    target: "et75v91"
})("min-width:112px;width:auto;");
var AuthNav = /*#__PURE__*/ (0,emotion_styled_browser_esm["default"])("nav", {
    target: "et75v92"
})("display:flex;gap:40px;align-items:center;");
var LinkLabel = /*#__PURE__*/ (0,emotion_styled_browser_esm["default"])("a", {
    target: "et75v93"
})(function(param) {
    var theme = param.theme;
    return (0,emotion_react_browser_esm.css)(_templateObject(), theme.colors.gray4, theme.font.sizes.medium, theme.font.weight.normal);
});

;// CONCATENATED MODULE: ./src/components/molecules/AuthHeaderNav/AuthHeaderNav.tsx






var AuthHeaderNav = function() {
    var router = (0,next_router.useRouter)();
    var isLandingPage = /^\/$/.test(router.route);
    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm.jsxs)(Wrapper, {
        children: [
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm.jsx)(next_link["default"], {
                href: "/",
                passHref: true,
                children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm.jsx)(Logo, {
                    children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm.jsx)(next_image["default"], {
                        src: "/img/logo.svg",
                        alt: "Riiid for Classrooms logo",
                        width: 100,
                        height: 30,
                        placeholder: "blur",
                        blurDataURL: "/img/logo.svg"
                    })
                })
            }),
            isLandingPage && /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm.jsxs)(AuthNav, {
                children: [
                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm.jsx)(next_link["default"], {
                        href: "/signin",
                        passHref: true,
                        children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm.jsx)(LinkLabel, {
                            children: "Sign In"
                        })
                    }),
                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm.jsx)(next_link["default"], {
                        href: "/signup",
                        passHref: true,
                        children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm.jsx)(LinkLabel, {
                            children: "Sign Up"
                        })
                    })
                ]
            })
        ]
    });
};
/* harmony default export */ var AuthHeaderNav_AuthHeaderNav = (AuthHeaderNav);

;// CONCATENATED MODULE: ./src/components/molecules/AuthHeaderNav/index.ts


;// CONCATENATED MODULE: ./src/layouts/Auth/styles.ts

var styles_Wrapper = /*#__PURE__*/ (0,emotion_styled_browser_esm["default"])("div", {
    target: "e703ikv0"
})("display:grid;grid-template-rows:auto 1fr;gap:40px;grid-gap:40px;padding:60px;width:100%;min-height:100vh;height:100%;");

;// CONCATENATED MODULE: ./src/layouts/Auth/index.tsx




var AuthLayout = function(param) {
    var children = param.children;
    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm.jsxs)(styles_Wrapper, {
        children: [
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm.jsx)(AuthHeaderNav_AuthHeaderNav, {}),
            children
        ]
    });
};
/* harmony default export */ var Auth = (AuthLayout);


/***/ }),

/***/ 55571:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ Auth; }
});

// EXTERNAL MODULE: ../../node_modules/@emotion/react/jsx-runtime/dist/emotion-react-jsx-runtime.browser.esm.js
var emotion_react_jsx_runtime_browser_esm = __webpack_require__(52903);
// EXTERNAL MODULE: ../../node_modules/next/image.js
var next_image = __webpack_require__(96577);
// EXTERNAL MODULE: ../../node_modules/react/index.js
var react = __webpack_require__(2784);
// EXTERNAL MODULE: ../../node_modules/@emotion/styled/dist/emotion-styled.browser.esm.js + 4 modules
var emotion_styled_browser_esm = __webpack_require__(82227);
;// CONCATENATED MODULE: ./src/templates/Auth/styles.ts

var Wrapper = /*#__PURE__*/ (0,emotion_styled_browser_esm["default"])("main", {
    target: "e13yas810"
})("display:flex;justify-content:space-between;align-items:center;padding:0 70px;height:100%;");
var IllustrationWrapper = /*#__PURE__*/ (0,emotion_styled_browser_esm["default"])("div", {
    target: "e13yas811"
})("display:flex;justify-content:right;height:610px;");

;// CONCATENATED MODULE: ./src/templates/Auth/index.tsx




var AuthTemplate = function(param) {
    var illustrationSrc = param.illustrationSrc, illustrationAlt = param.illustrationAlt, children = param.children;
    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm.jsxs)(Wrapper, {
        children: [
            children,
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm.jsx)(IllustrationWrapper, {
                children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm.jsx)(next_image["default"], {
                    src: illustrationSrc,
                    alt: illustrationAlt
                })
            })
        ]
    });
};
/* harmony default export */ var Auth = (AuthTemplate);


/***/ }),

/***/ 98404:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "y": function() { return /* binding */ isDevelopment; }
/* harmony export */ });
var isDevelopment = "production" !== "production";


/***/ })

}]);